import { CURRENCY } from '~../__queries__';
import { useStorage } from '~Components/Storage';
import { useSelector } from '~Hooks';

// {new-country-onboarding} Add all new currencies here
const currencyToSymbolMap: Record<CURRENCY | string, string> = {
  [CURRENCY.DKK]: 'kr',
  [CURRENCY.EUR]: '€',
  [CURRENCY.NOK]: 'nkr',
  [CURRENCY.USD]: '$',
  [CURRENCY.SEK]: 'kr',
  [CURRENCY.GBP]: '£',
  TRY: '₺',
  AED: 'د.إ',
};

// {new-country-onboarding} Add all new currencies here
const currencyToLocaleMap: Record<CURRENCY | string, string> = {
  [CURRENCY.DKK]: 'da-DK',
  [CURRENCY.EUR]: 'nl-NL',
  [CURRENCY.NOK]: 'nb-NO',
  [CURRENCY.USD]: 'en-US',
  [CURRENCY.SEK]: 'sv-SE',
  [CURRENCY.GBP]: 'en-GB',
  TRY: 'tr-TR',
  AED: 'ar-AE',
};

// {new-country-onboarding} Add all new currencies here
export const nonLegacyCurrencies: Record<string, string> = {
  TR: 'TRY',
  AE: 'AED',
};

const twoDecimalCurrencies = [CURRENCY.GBP, CURRENCY.EUR, 'TRY', 'AED'];

export const useCurrency = () => {
  const country = useSelector((state) => state.country);

  const [storage] = useStorage();

  const currencyType =
    country && nonLegacyCurrencies[country] ? nonLegacyCurrencies[country] : storage.currency.code;

  const showTwoDecimals = twoDecimalCurrencies.includes(currencyType);

  const format = (amount: number, divide = true): string => {
    // Guard, if the currency type is misstyped/is not supported
    if (!currencyType) {
      return (divide ? amount / 100 : amount).toString();
    }

    const formatter = new Intl.NumberFormat(currencyToLocaleMap[currencyType], {
      style: 'currency',
      currency: currencyType,
      minimumFractionDigits: showTwoDecimals ? 2 : 0,
      maximumFractionDigits: 2,
    });

    // If the amount is negative, the formatter will return it as a normal dash instead of '−'(U+2212) otherwhise the negative sign will be "?" mark on epson printers
    return formatter.format(divide ? amount / 100 : amount).replace('−', '-');
  };

  const symbol = (currencyCode?: CURRENCY) => {
    return country && nonLegacyCurrencies[country]
      ? currencyToSymbolMap[currencyType]
      : currencyToSymbolMap[currencyCode || 'SEK'];
  };

  return {
    format,
    symbol,
    code: storage.currency.code,
  };
};
